import { combineReducers } from 'redux';

import users from './users/users.reducer';
import loader from './loader/loader.reducer';

export default combineReducers({
  users,
  loader,
});